import { useParams } from "react-router-dom";
import SubscriptionPlansPage from "../../../modules/billing/subscription-plans/SubscriptionPlansPage";

const EditSubscription = () => {
  const { Id } = useParams();

  return <SubscriptionPlansPage routeModalMode="edit" routeModalId={Id} />;
};

export default EditSubscription;
